import styled from "styled-components";
import { FaTimes } from "react-icons/fa";
import { Link as LinkS } from "react-scroll";

export const DropMenuContainer = styled.aside`
  position: fixed;
  z-index: 999;
  width: 100%;
  height: 100%;
  background: #0e1a24;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  transition: 0.3s ease-in-out;
  opacity: ${({ isOpen }) => (isOpen ? "100" : "0")};
  top: ${({ isOpen }) => (isOpen ? "0" : "-100%")};
`;

export const CloseIcon = styled(FaTimes)`
  color: #fff;
`;

export const Icon = styled.div`
  position: absolute;
  top: 1.2rem;
  right: 1.5rem;
  background: transparent;
  font-size: 2rem;
  cursor: pointer;
  outline: none;
`;

export const DropMenuWrapper = styled.div`
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
`;

export const DropMenuLink = styled(LinkS)`
  display: flex;
  line-item: center;
  justify-content: center;
  font-size: 1.5rem;
  margin-top: 0;
  text-decoration: none;
  list-style: none;
  transition: 0.2s ease-in-out;
  color: #fff;
  cursor: pointer;
  &:hover {
    color: #ffcb66;
    transition: 0.2s ease-in-out;
  }
`;

export const DropMenuList = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 28px;

  @media screen and (max-width: 480px) {
    gap: 38px;
  }
`;

export const BtnWrap = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 0;
  height: 40px;
`;

export const NavButton = styled.a`
  border-radius: 50px;
  background: ${({ primary }) => (primary ? "#ffcb66" : "#010606")};
  white-space: nowrap;
  padding: ${({ big }) => (big ? "14px 48px" : "12px 30px")};
  color: ${({ dark }) => (dark ? "#010606" : "#fff")};
  font-size: ${({ fontBig }) => (fontBig ? "20px" : "16px")};
  outline: none;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: ${({ primary }) => (primary ? "#FFF" : "#ffcb66")};
    color: #000;
  }
`;
